import React, { useEffect, useState } from "react";
import { FaAngleLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAUser,
  getGetUserStatus,
  getUpdateUserStatus,
  getUserError,
  updateUser,
} from "../../../redux/slice/usersSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";

const ROLES = [
  { id: 1, role: "ADMIN", display: "Admin" },
  { id: 2, role: "EDITOR", display: "Editor" },
  { id: 3, role: "CLIENT", display: "Client" },
];

const EditUserForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector(getAUser);
  const getStatus = useSelector(getGetUserStatus);
  const updateStatus = useSelector(getUpdateUserStatus);
  const error = useSelector(getUserError);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [role, setRole] = useState("");

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");

  useEffect(() => {
    if (getStatus === "success") {
      setName(user?.name);
      setEmail(user?.email);
      setMobileNumber(user?.mobileNumber);
      setRole(user?.role);
    }
  }, [getStatus, user]);

  const handleBack = () => {
    navigate(-1);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    var err = false;

    const nameRegex = /^\w+\s\w+$/;
    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

    if (name === "") {
      setNameError("Name is required");
      err = true;
    } else if (!nameRegex.test(name)) {
      setNameError("Enter valid full name");
      err = true;
    }
    if (email === "") {
      setEmailError("Email is required");
      err = true;
    } else if (!emailRegex.test(email)) {
      setEmailError("Not a valid email");
      err = true;
    }
    if (mobileNumber === "") {
      setMobileNumberError("Mobile no. is required");
      err = true;
    } else if (mobileNumber.toString().length !== 10) {
      setMobileNumberError("Mobile number must be 10 digit in length");
      err = true;
    } else if (isNaN(mobileNumber)) {
      setMobileNumberError("Enter a numeric value");
      err = true;
    }
    if (!err) {
      const userData = {
        id: user._id,
        data: { name, email, mobileNumber, role },
      };
      dispatch(updateUser(userData));
    }
  };

  return (
    <div className="flex flex-col w-full sm:gap-12 gap-6">
      {getStatus === "loading" || updateStatus === "loading" ? (
        <Loading />
      ) : null}
      {getStatus === "failed" || updateStatus === "failed" ? (
        <AlertBox type="failed" message={error} />
      ) : null}
      {updateStatus === "success" ? (
        <AlertBox type="success" message="User updated successfully" />
      ) : null}
      <div className="flex w-full justify-between items-center">
        <span className="text-[24px] font-semibold text-adminTextSecondary">
          Edit user
        </span>
      </div>
      <div className="bg-primary flex flex-col gap-10 w-full sm:p-7 p-3 rounded-[4px] border border-adminMainBorder">
        <button
          type="button"
          onClick={handleBack}
          className="w-14 flex flex-row gap-2 items-center"
        >
          <FaAngleLeft />
          <span>Back</span>
        </button>
        <form
          onSubmit={handleUpdate}
          className="flex flex-col gap-4 sm:px-4 px-0 justify-center items-center"
        >
          <div className="flex flex-col gap-4 sm:w-[400px]">
            <div className="flex flex-col gap-1 w-full">
              <label htmlFor="name" className="font-semibold text-textPrimary">
                Name:
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setNameError("");
                }}
                className="admin-input-box text-textSecondary"
              />
              <span className="pl-4 text-[12px] italic text-red-500">
                {nameError}
              </span>
            </div>
            <div className="flex flex-col gap-1 w-full">
              <label htmlFor="email" className="font-semibold text-textPrimary">
                Email:
              </label>
              <input
                type="text"
                id="email"
                name="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setEmailError("");
                }}
                className="admin-input-box text-textSecondary "
              />
              <span className="pl-4 text-[12px] italic text-red-500">
                {emailError}
              </span>
            </div>
            <div className="flex flex-col gap-1 w-full">
              <label
                htmlFor="mobile"
                className="font-semibold text-textPrimary"
              >
                Mobile No.:
              </label>
              <input
                type="text"
                id="mobile"
                name="mobile"
                value={mobileNumber}
                onChange={(e) => {
                  setMobileNumber(e.target.value);
                  setMobileNumberError("");
                }}
                className="admin-input-box text-textSecondary"
              />
              <span className="pl-4 text-[12px] italic text-red-500">
                {mobileNumberError}
              </span>
            </div>

            <div className="flex flex-col gap-1 w-full">
              <label htmlFor="role" className="font-semibold text-textPrimary">
                Role:
              </label>
              <div className="flex flex-row justify-between items-center px-2">
                {ROLES.map((_role) => (
                  <div key={_role.id} className="flex flex-row gap-2">
                    <input
                      type="radio"
                      name="role"
                      id={_role.id}
                      value={_role.role}
                      className=""
                      onChange={(e) => setRole(e.target.value)}
                      checked={_role.role === role}
                    />
                    <label htmlFor={_role.id} className="text-textPrimary">
                      {_role.display}
                    </label>
                  </div>
                ))}
              </div>
            </div>

            <div className="self-end mt-2">
              <button
                type="submit"
                className="text-white bg-adminRightTextPrimary h-[32px] px-6 text-sm rounded-[4px]"
              >
                <span>Update</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserForm;
